<template>
  <v-app id="inspire">
    <!-- <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>-->

    <!-- <v-app-bar app clipped-left flat color="#356D88">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <v-img src="./assets/tecsvit_dev_logo.png"></v-img>
      </v-toolbar-title>
    </v-app-bar>-->

    <!-- <v-content>
      <v-container fluid class="pa-0">
        <v-row align="center" justify="center">
          <v-col class="pt-0">
            <v-card elevation="0">
              <v-img
                class="white--text align-end"
                max-height="35vh"
                src="./assets/img/person-looking-at-phone-and-at-macbook-pro-1181244.jpg"
              >
                <v-card-title>
                  <h1 display-4>Professional mobile and web development</h1>
                </v-card-title>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 id="about" display-3>About</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 id="tech-stack" display-3>Tech-stack</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 id="projects" display-3>Projects</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 id="team" display-3>Team</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 id="contacts" display-3>Contacts</h2>
          </v-col>
        </v-row>
      </v-container>
    </v-content>-->
    <div id="logo" :class="{'logo-top': logoTop}"></div>
    <div :class="{ carousel: logoTop, 'carousel-hidden': !logoTop }">
      <HomeAboutCarousel />
      <HomeTechStack />
      <HomePortfolioCarousel />
      <HomeContacts />
    </div>
    <v-footer app color="#3388aa" class="justify-center">
      <span>&copy; 2006-{{ year }} Tecsvit Development</span>
    </v-footer>
  </v-app>
</template>

<script>
import HomeAboutCarousel from "./components/HomeAboutCarousel";
import HomePortfolioCarousel from "./components/HomePortfolioCarousel";
import HomeTechStack from "./components/HomeTechStack";
import HomeContacts from "./components/HomeContacts";
export default {
  props: {
    source: String
  },
  components: { HomeAboutCarousel, HomeTechStack, HomeContacts, HomePortfolioCarousel },
  data: () => ({
    drawer: null,
    logoTop: false
  }),

  created() {
    this.$vuetify.theme.dark = true;
  },
  mounted() {
    let _this = this;
    window.setTimeout(function() {
      _this.logoTop = true;
    }, 2000);
  },
  computed: {
    year() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./assets/scss/main.scss";
.carousel {
  transition: opacity 2s ease-out 1s;
  margin-top: 100px;
}
.carousel-hidden {
  opacity: 0;
}
#logo {
  transition: height 1s ease-out;
  position: absolute;
  &.logo-top {
    height: 100px !important;
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    right: 0;
  }
}
.content {
  margin-top: 100px;
  transition: opacity 2s ease-out 1s;
  opacity: 1;
  padding: 1rem;
  &.hidden {
    // visibility: hidden;
    opacity: 0;
  }
  .tech {
    font-size: 60px;
    color: #c3eeff;
    max-width: 600px;
    margin: 2rem auto;
    div {
      display: flex;
      justify-content: space-evenly;
      padding: 1rem;
    }
  }
}
.v-application {
  background-color: #3388aa !important;
}
</style>